import { render, staticRenderFns } from "./waiver.vue?vue&type=template&id=8a7dd12e&scoped=true"
import script from "./waiver.vue?vue&type=script&lang=js"
export * from "./waiver.vue?vue&type=script&lang=js"
import style0 from "./waiver.vue?vue&type=style&index=0&id=8a7dd12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7dd12e",
  null
  
)

export default component.exports